export const INTEGRATIONS_MARK_SIZE = Object.freeze({
  sm: "sm",
  lg: "lg",
});
